import * as React from 'react';
import { Page } from '../../cookbook-ui/Page_SC';
import { TitleText } from '../../cookbook-ui/custom-components/TitleText/TitleText';
import { Table } from '../../cookbook-ui/custom-components/Table/Table';
import { createShadowObject, formatShadowsForTable } from '../../utils/fns';
import { SHADOW_COLUMNS } from '../../utils/copy';
import { Blank } from '../intro-pages/Home/FAQ_SC';

export interface Props {}

export const Shadows: React.FC<Props> = (props) => {
  React.useEffect(() => {
    const scroll = () => {
      const lastBit = window.location.href.split('/').slice(-1)[0];
      if (lastBit.split('#').length > 1) {
        const element = document.querySelector(`#${lastBit.split('#')[1]}`);
        element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };
    window.addEventListener('load', scroll);
    return () => window.removeEventListener('load', scroll);
  }, []);

  const shadowObj = createShadowObject();

  let mappedShadows = shadowObj.map((shadow) => {
    return (
      <>
        <br id={shadow.title} />
        <br />
        <TitleText headerText={shadow.title} footerText="" />
        <Table
          columns={SHADOW_COLUMNS}
          rows={formatShadowsForTable(shadow.shadowArr)}
          customColumnWidth={[
            {
              index: 0,
              minWidth: 60,
              maxWidth: '80',
            },
            {
              index: 1,
              minWidth: 60,
              maxWidth: '80',
            },
            {
              index: 2,
              minWidth: 100,
              maxWidth: 'unset',
            },
            {
              index: 3,
              minWidth: 100,
              maxWidth: 'unset',
            },
          ]}
          uniformWidth={500}
        />
        <br />
      </>
    );
  });

  return (
    <Page>
      <TitleText
        headerText="Shadows"
        footerText="Used to show elevation or importance in XI. Shadows are helpful to add layer to hierarchy to a page. There are four groups of shadows, and seven levels in each group."
        isLargeHeader
      />
      <hr />
      {mappedShadows}
      <Blank />
    </Page>
  );
};
